<template lang="pug">
#course_type
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    .training-camp-card(
      v-for="courseType in coureseTypes",
      :key="courseType.id"
    )
      .row
        .col-12.col-md-3
          .training-camp-image(
            v-if="courseType.photo",
            :style="{ backgroundImage: 'url(' + courseType.photo.image + ')' }"
          )
        .col-12.col-md-9
          .training-camp-info
            .training-camp-title
              img.top-basketball-icon(
                src="@/assets/img/icons/icon_small_basketball.png"
              )
              span.icon-title {{ courseType.name }}
                .training-camp-desc.mt-3 {{ courseType.description }}

            .btn.strength-btn.float-right(
              @click="readMoreClick(courseType.id)"
            ) 了解更多

  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getCourseTypeList } from "@/api/web_content";

export default {
  name: "CourseIntro",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "課程介紹",
      coureseTypes: [],
    };
  },
  created() {
    this.getCourseTypes();
  },
  methods: {
    getCourseTypes() {
      getCourseTypeList().then((response) => {
        this.coureseTypes = response.data;
      });
    },
    readMoreClick(courseTypeId) {
      this.$router.push({
        name: "CourseIntroDetail",
        query: { id: courseTypeId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
#course_type {
  background-color: #fafafa;
}

.training-camp-card {
  width: 100%;
  margin: 20px auto;
  box-shadow: 2px 2px 16px #00000023;
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;

  .training-camp-info {
    font-size: 1rem;
    padding: 1rem 1rem 1rem 0;
    height: 100%;
    position: relative;

    .btn {
      // position: absolute;
      // bottom: 1rem;
      // right: 1rem;
      margin-bottom: 1rem;
    }
    .training-camp-title {
      margin-bottom: 15px;
    }

    .training-camp-desc {
      font-size: 14px;
      color: #363636;
      min-height: 7vw;
    }

    .training-camp-district-wrapper {
      position: absolute;
      bottom: 0;
      right: 1rem;
      width: calc(100% - 1rem);
      padding: 1rem 0;
      border-top: 1px solid #979797;
      min-height: 72px;

      .training-camp-district {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        font-size: 16px;
        color: $color_water_blue;
        line-height: 26px;
        padding-right: 100px;

        a {
          color: $color_water_blue;
          text-decoration: underline;
        }

        span {
          margin: 0 5px;
        }
      }
    }
  }

  .training-camp-image {
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    min-height: 15vw;
  }
}

@media (max-width: 767px) {
  .training-camp-card {
    .training-camp-image {
      height: 68vw;
    }

    .training-camp-info {
      padding: 1rem;

      .training-camp-district-wrapper {
        margin-top: 1rem;
        position: relative;
        bottom: 0;
        right: 0;
        width: 100%;
        padding-bottom: 0;
        min-height: 50px;
      }
    }
  }
}

@media (max-width: 575px) {
  .training-camp-card {
    .training-camp-image {
      height: 85vw;
    }
  }
}
</style>
